import React from 'react';
import { clsx } from '../utils/utils';
import * as styles from './Button.module.scss';
import Caption, { CaptionProps } from './Caption';

export interface ButtonProps extends CaptionProps {
  secondary?: boolean;
  small?: boolean;
  smallFont?: boolean;
  pressed?: boolean;
  disabled?: boolean;
}

const Button = ({
  secondary,
  small,
  smallFont = false,
  className,
  pressed,
  disabled,
  ...restProps
}: ButtonProps): React.ReactElement => {
  return (
    <Caption
      small={small}
      className={clsx(
        styles.button,
        secondary && styles.secondary,
        small && styles.small,
        smallFont && styles.smallFont,
        pressed && styles.pressed,
        disabled && styles.disabled,
        className,
      )}
      role="button"
      {...restProps}
    ></Caption>
  );
};

export default Button;
